import React, { FC, Fragment, ReactNode } from 'react'

import './Label.scss'

interface Props {
  isRequired?: boolean
  children?: ReactNode
}

export const Label: FC<Props> = ({ isRequired = false, children }) => {
  if (isRequired) {
    return (
      <Fragment>
        {children}
        <span className="required-asterisk">*</span>
      </Fragment>
    )
  }

  return children
}
